import React from 'react';
import { useForm } from 'react-hook-form';
import { Box, Button, FormControl, FormLabel, Input, useToast } from '@chakra-ui/react';
import PerguntasController from 'controllers/Perguntas/PerguntasController';

export function LLMForm({ questionId, onClose }) {
  const { register, handleSubmit } = useForm();
  const toast = useToast()

  const onSubmit = (data) => {
    const response = PerguntasController.ReProc(questionId, 1, data.new_question, 0)

    if(!response) {
      toast({
        title: 'Erro ao processar',
        description: response.msg,
        status: 'error',
        duration: 9000,
        isClosable: true,
      })

      return
    }

    onClose()
    toast({
      title: 'Processado com sucesso!',
      description: response.msg,
      status: 'success',
      duration: 9000,
      isClosable: true,
    })
  };

  return (
    <Box maxW="md" mx="auto" mt={5} p={5} borderWidth={1} borderRadius="lg">
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormControl id="new_question" mb={4}>
          <FormLabel>LLM</FormLabel>
          <Input {...register("new_question")} placeholder="Insira uma pergunta..." />
        </FormControl>
        <Button type="submit" colorScheme="blue">Cadastrar</Button>
      </form>
    </Box>
  );
}
